<template>
  <div class="notification-container" :class="{ color }" v-show="state_visible">
    <div class="message">
      <div class="notification-icon">
        <img :src="getImage()" alt />
      </div>
      <div class="notification-message">
        <p>{{ message }}</p>
      </div>
    </div>
    <div class="notification-close-button">
      <img src="@/assets/img/close-icon.png" alt @click="hide" />
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/eventHub";

export default {
  name: "NotificationClient",
  data() {
    return {
      state_visible: false,
      message: "",
      color: "",
      img: ""
    };
  },
  methods: {
    show() {
      this.state_visible = true;
    },
    hide() {
      this.state_visible = false;
    },
    getImage() {
      if (this.img) {
        return require(`@/assets/img/${this.img}`);
      }
      return;
    },
    showSuccessNotification(message) {
      this.showNotification(message, "success-icon.png", "green");
    },
    showWarningNotification(message) {
      this.showNotification(message, "warning-icon.png", "yellow");
    },
    showErrorNotification(message) {
      this.showNotification(message, "error-icon.png", "red");
    },
    showNotification(message, icon, color) {
      this.message = message;
      this.img = icon;
      this.color = color;
      this.state_visible = true;
    },
    hideNotification() {
      this.state_visible = false;
    }
  },
  created() {
    EventBus.$on("showRegisterUserNotification", $event => {
      this.showSuccessNotification($event);
    });

    EventBus.$on("showSuccessNotification", message => {
      this.showSuccessNotification(message);
    });

    EventBus.$on("showWarningNotification", message => {
      this.showWarningNotification(message);
    });

    EventBus.$on("showErrorNotification", message => {
      this.showErrorNotification(message);
    });

    EventBus.$on("hideNotification", () => {
      this.hideNotification();
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.notification-container {
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 75px;
  border: 0.1px solid $grey3;
  padding: 5px;
  box-shadow: 5px 5px 10px -6px black;

  .message {
    display: flex;
  }
}
.notification-close-button img {
  width: 15px;
  height: 15px;
  position: relative;
  top: 15%;
  right: 15%;
  transform: translate(0, -50%);
}
.notification-close-button:hover {
  cursor: pointer;
}
.notification-icon img {
  width: 30px;
  height: 30px;
  position: relative;
  top: 50%;
  left: 5%;
  transform: translate(0, -50%);
}
.notification-message {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
}
</style>
